export type DeleteComponentConversionRulesResponse = {};
